export const WINDOW_ISSUES = [
  {
    title: 'My windows leak or get condensation ',
    icon: {
      url: 'assets/icons/window-issues/windows-leak.svg',
    },
    unique_name: '876090000',
  },
  {
    title: 'I have a broken window frame or glass',
    icon: {
      url: 'assets/icons/window-issues/window-broken.svg',
    },
    unique_name: '876090001',
  },
  {
    title: 'I have trouble opening and closing my windows',
    icon: {
      url: 'assets/icons/window-issues/trouble-opening.svg',
    },
    unique_name: '876090002',
  },
  {
    title: 'My windows are rotted or moldy',
    icon: {
      url: 'assets/icons/window-issues/rotted-moldy.svg',
    },
    unique_name: '876090003',
  },
];
